import { makeStyles } from '@material-ui/core/styles';

const useHighlightStyles = makeStyles(theme => ({
  root: {
    background: '#fff8e1',
    borderRadius: 12,
    marginBottom: theme.spacing(1.5),
    boxShadow: 'none',
    border: '1px solid #f5e19d',
    overflow: 'hidden',
    margin: 0,
  },
  panelRoot: {
    margin: 0,
    marginTop: 8,
    '&$panelExpanded': {
      margin: 0,
      marginTop: 8,
    },
  },
  panelExpanded: {},
  summary: {
    background: '#fff8e1',
    '& .MuiExpansionPanelSummary-content': {
      alignItems: 'center',
      margin: 0,
    },
    '& .MuiExpansionPanelSummary-expandIcon': {
      color: '#bfa80c',
      transform: 'rotate(0deg)',
      transition: 'transform 0.2s ease-in-out',
    },
    '&.Mui-expanded .MuiExpansionPanelSummary-expandIcon': {
      transform: 'rotate(180deg)',
    },
  },

  summaryRoot: {
    minHeight: 40,
    '&$expanded': {
      minHeight: 40,
    },
  },
  summaryContent: {
    margin: 0,
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},

  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  titleDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#fdd835',
  },
  titleText: {
    fontWeight: 600,
    color: '#8c6f00',
    fontSize: 15,
  },
  counter: {
    color: '#a18700',
    fontWeight: 500,
    marginLeft: 4,
    fontSize: 13,
    opacity: 0.8,
  },
  details: {
    padding: theme.spacing(1, 2, 1.5),
    background: '#fffef6',
    borderTop: '1px solid #f5e19d',
  },
  scroller: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(260px, 1fr)',
    gap: theme.spacing(1.5),
    overflowX: 'auto',
    scrollbarWidth: 'thin',
    paddingBottom: theme.spacing(2),
    '&::-webkit-scrollbar': {
      height: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#e0c768',
      borderRadius: 4,
    },
    '&::-webkit-scrollbar-track': {
      background: '#fff8e1',
    },
  },
}));

export default useHighlightStyles;
